// /* global google */

// import {
//   GoogleMap,
//   Marker,
//   InfoWindow,
//   Polyline,
//   Polygon,
//   Circle,
//   MarkerClusterer,
// } from "@react-google-maps/api";
// import { useState, useEffect, useMemo, useRef } from "react";
// import MDTypography from "components/MDTypography";
// import MDBox from "components/MDBox";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useMediaQuery } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import axios from "axios";

// // Assets
// import StopIcon from "assets/images/stop_marker.png";
// import focus from "assets/focus.png";
// import focus_dark from "assets/focus-dark.png";
// import satellite from "assets/satellite.png";
// import satellite_dark from "assets/satellite-dark.png";
// import label_dark from "assets/label-dark.png";
// import label from "assets/label.png";
// import realShip from "assets/images/ship.png"

// // Components & Redux Actions
// import VehicleDashboard from "./VehicleDashboard";
// import { setSelectedVehicleNumber } from "../../features/live_map/fleetSlice";

// const containerStyle = {
//   width: "100%",
//   height: "880px",
//   borderRadius: "10px",
// };

// const defaultCenter = {
//   lat: 3.2028,
//   lng: 73.2207
// };

// const btnStyle = {
//   background: "#fff",
//   padding: "4px",
//   borderRadius: "8px",
//   cursor: "pointer",
//   border: "none",
//   fontWeight: "600",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   minWidth: "30px",
//   minHeight: "30px"
// };

// // --- Icon Caching & Processing ---
// const iconCache = {};
// const getCachedIcon = async (bearing = 0) => {
//   const safeBearing = parseFloat(bearing) || 0;
//   const cacheKey = `bus-${safeBearing}`;
//   if (iconCache[cacheKey]) return iconCache[cacheKey];

//   const canvas = document.createElement("canvas");
//   const ctx = canvas.getContext("2d");
//   const size = 120;

//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => {
//       canvas.width = size;
//       canvas.height = size;
//       ctx.translate(size / 2, size / 2);
//       ctx.rotate((safeBearing * Math.PI) / 180);
//       ctx.translate(-size / 2, -size / 2);
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = "high";
//       ctx.drawImage(img, 0, 0, size, size);
//       const url = canvas.toDataURL();
//       iconCache[cacheKey] = url;
//       resolve(url);
//     };
//     img.onerror = () => resolve(realShip);
//     img.src = realShip;
//   });
// };

// const getVehicleColor = (vehicle) => {
//   const speed = parseFloat(vehicle.speed);
//   const now = Date.now();
//   const isStale = vehicle.rawTime && vehicle.rawTime + 3600000 < now;
//   if (isStale) return "#9e9e9e";
//   if (vehicle.ignition === "ON" && speed > 0) return "#4caf50";
//   if (vehicle.ignition === "ON" && speed === 0) return "#ff9800";
//   if (vehicle.ignition === "OFF") return "#f44336";
//   return "#9e9e9e";
// };

// // --- SmoothMarker Component ---
// const SmoothMarker = ({ position, vehicle, children, onPositionChange, clusterer, ...props }) => {
//   const [renderPosition, setRenderPosition] = useState(position);
//   const positionRef = useRef(position);
//   const animationRef = useRef(null);
//   const [iconUrl, setIconUrl] = useState("");
//   const [marker, setMarker] = useState(null);

//   useEffect(() => {
//     let isMounted = true;
//     const loadIcon = async () => {
//       const bearing = parseFloat(vehicle.bearing) || 0;
//       const icon = await getCachedIcon(bearing);
//       if (isMounted) setIconUrl(icon);
//     };
//     loadIcon();
//     return () => { isMounted = false; };
//   }, [vehicle.bearing]);

//   useEffect(() => {
//     const startPos = positionRef.current;
//     const endPos = position;
//     if (!startPos || !endPos) return;
//     if (startPos.lat === endPos.lat && startPos.lng === endPos.lng) return;

//     const distanceThreshold = 0.5; // If marker jumps too far suddenly
//     if (Math.abs(startPos.lat - endPos.lat) > distanceThreshold || Math.abs(startPos.lng - endPos.lng) > distanceThreshold) {
//       setRenderPosition(endPos);
//       positionRef.current = endPos;

//       // 🔥 FIX: Force clusterer to repaint so it doesn't lose the marker when it jumps
//       if (clusterer && typeof clusterer.repaint === 'function') {
//         setTimeout(() => clusterer.repaint(), 50);
//       }
//       return;
//     }

//     const startTime = performance.now();
//     const duration = 4000;
//     const animate = (time) => {
//       const elapsed = time - startTime;
//       const progress = Math.min(elapsed / duration, 1);
//       const lat = startPos.lat + (endPos.lat - startPos.lat) * progress;
//       const lng = startPos.lng + (endPos.lng - startPos.lng) * progress;
//       const currentPos = { lat, lng };

//       setRenderPosition(currentPos);
//       positionRef.current = currentPos;
//       onPositionChange && onPositionChange(currentPos);

//       if (progress < 1) animationRef.current = requestAnimationFrame(animate);
//     };

//     animationRef.current = requestAnimationFrame(animate);
//     return () => { if (animationRef.current) cancelAnimationFrame(animationRef.current); };
//   }, [position, clusterer]);

//   return (
//     <Marker
//       position={renderPosition}
//       clusterer={clusterer}
//       onLoad={(m) => setMarker(m)}
//       icon={{
//         url: iconUrl,
//         scaledSize: new window.google.maps.Size(60, 60),
//         anchor: new window.google.maps.Point(30, 30),
//       }}
//       {...props}
//     >
//       {marker && children}
//     </Marker>
//   );
// };

// // --- MAIN COMPONENT ---
// const GoogleMapView = ({ onVehicleSelect }) => {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const navigate = useNavigate();

//   const { myThings, latestUpdates, selectedVehicleNumber, activeFilter, geoFences, searchQuery } = useSelector((state) => state.fleet);

//   const [selectedVehicle, setSelectedVehicle] = useState(null);
//   const [selectedStop, setSelectedStop] = useState(null);
//   const [openInfoVehicleId, setOpenInfoVehicleId] = useState(null);

//   const mapRef = useRef(null);
//   const [isMapReady, setIsMapReady] = useState(false);

//   const [pulseRadius, setPulseRadius] = useState(20);
//   const [pulseOpacity, setPulseOpacity] = useState(0.4);
//   const [animatedPosition, setAnimatedPosition] = useState(null);
//   const [showAllLabels, setShowAllLabels] = useState(false);
//   const [mapType, setMapType] = useState("hybrid");

//   const [autoFocus, setAutoFocus] = useState(false); // Default OFF — continuous tracking as the vehicle moves
//   const [enableClustering, setEnableClustering] = useState(true);
//   const [showGeofences, setShowGeofences] = useState(true); // Default ON

//   const initialFocusDone = useRef(false);
//   const lastFocusedVehicleRef = useRef(null); // tracks which vehicle we've already auto-centered on

//   // Pulse effect logic
//   useEffect(() => {
//     if (!selectedVehicle) return;
//     let growing = true;
//     const interval = setInterval(() => {
//       setPulseRadius((prev) => {
//         if (prev > 60) growing = false;
//         if (prev < 30) growing = true;
//         return growing ? prev + 4 : prev - 4;
//       });
//       setPulseOpacity((prev) => prev > 0.4 ? 0.1 : 0.4);
//     }, 100);
//     return () => clearInterval(interval);
//   }, [selectedVehicle]);

//   // Data mapping logic
//   const vehicles = useMemo(() => {
//     if (!myThings) return [];
//     return Object.entries(myThings).map(([vehicleNumber, data]) => {
//       const latest = latestUpdates[vehicleNumber]?.latest?.MOBILE || data?.latest?.MOBILE || {};
//       const location = latest?.location || {};
//       const journeyAvailable = data?.journeyAvailable === true;
//       const journeyData = data?.currentJourney || {};
//       const stops = data?.stops || {};

//       const lat = parseFloat(location.latitude);
//       const lng = parseFloat(location.longitude);
//       const hasValidLocation = !isNaN(lat) && !isNaN(lng);

//       return {
//         vehicleNumber: data?.thing?.thingId,
//         vehicleNickName: data?.thing?.nickName,
//         position: hasValidLocation ? { lat, lng } : null,
//         hasValidLocation: hasValidLocation,
//         ignition: latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
//         bearing: latest?.bearing ?? data?.latest?.MOBILE?.bearing,
//         speed: latest?.speed ? parseFloat(latest.speed).toFixed(2) : "0.00",
//         rawTime: latest?.updatedAt || "",
//         routeCoordinates: journeyData?.wayPointsPolyLine || [],
//         stops: journeyAvailable ? stops || {} : {},
//         geofence: journeyData?.geofence || [],
//         journeyAvailable,
//       };
//     });
//   }, [myThings, latestUpdates]);

//   const filteredVehicles = useMemo(() => {
//     const now = Date.now();

//     return vehicles.filter((v) => {
//       // 🔥 FIX: Hide vehicles that don't have valid coordinates yet
//       if (!v.hasValidLocation || !v.position) return false;

//       let matchesFilter = true;
//       const isStale = v.rawTime + 3600000 < now;
//       const speed = parseFloat(v.speed);

//       switch (activeFilter) {
//         case "@running":
//           matchesFilter = !isStale && v.ignition === "ON" && speed >= 0.25;
//           break;
//         case "@idle":
//           matchesFilter = !isStale && v.ignition === "ON" && speed < 0.25;
//           break;
//         case "@parked":
//           matchesFilter = !isStale && v.ignition === "OFF";
//           break;
//         case "@offline":
//           matchesFilter = isStale;
//           break;
//         case "@onroute":
//           matchesFilter = v.journeyAvailable === true;
//           break;
//         default:
//           matchesFilter = true;
//       }

//       // 🔥 FIX: searchQuery doubles as the active-filter sentinel (e.g. "@running") when a
//       // filter chip is selected — that's not real search text, so it must not be matched
//       // against vehicle number/nickname, or every vehicle gets filtered out.
//       const rawQuery = searchQuery || "";
//       const q = rawQuery.startsWith("@") ? "" : rawQuery.toLowerCase();
//       const matchesSearch = v.vehicleNumber.toLowerCase().includes(q) ||
//         v.vehicleNickName.toLowerCase().includes(q);

//       return matchesFilter && matchesSearch;
//     });
//   }, [vehicles, activeFilter, searchQuery]);

//   // Sync selected vehicle with Redux State
//   useEffect(() => {
//     if (!selectedVehicleNumber) {
//       setSelectedVehicle(null);
//       setOpenInfoVehicleId(null);
//       return;
//     }
//     const found = vehicles.find(v => String(v.vehicleNumber) === String(selectedVehicleNumber));
//     setSelectedVehicle(found || null);
//   }, [vehicles, selectedVehicleNumber]);

//   // 🎯 Center & zoom on a vehicle the moment it's selected (clicking its card or its
//   // marker) — independent of the "Auto Focus" toggle, which only controls whether the
//   // map keeps following the vehicle as it continues to move afterwards.
//   useEffect(() => {
//     if (!mapRef.current || !selectedVehicle?.position) {
//       if (!selectedVehicle) lastFocusedVehicleRef.current = null;
//       return;
//     }
//     if (lastFocusedVehicleRef.current !== selectedVehicle.vehicleNumber) {
//       mapRef.current.panTo(selectedVehicle.position);
//       mapRef.current.setZoom(17);
//       lastFocusedVehicleRef.current = selectedVehicle.vehicleNumber;
//     }
//   }, [selectedVehicle]);


//   // 🔥 SECURE ONE-TIME INITIAL FOCUS LOGIC
//   useEffect(() => {
//     if (!isMapReady || !mapRef.current || initialFocusDone.current) return;

//     if (filteredVehicles.length > 0) {
//       const bounds = new window.google.maps.LatLngBounds();

//       filteredVehicles.forEach((v) => {
//         if (v.position?.lat && v.position?.lng) {
//           bounds.extend(v.position);
//         }
//       });

//       mapRef.current.fitBounds(bounds);

//       // Safe zoom handling using bounds_changed event
//       window.google.maps.event.addListenerOnce(mapRef.current, "bounds_changed", () => {
//         const zoom = mapRef.current.getZoom();
//         if (zoom > 16) mapRef.current.setZoom(16);
//         if (zoom < 5) mapRef.current.setZoom(5);
//       });

//       initialFocusDone.current = true; // Mark as done
//     }
//   }, [filteredVehicles, isMapReady]);


//   // Autofocus logic for manual toggles/selections
//   useEffect(() => {
//     if (!autoFocus || !mapRef.current) return;

//     if (selectedVehicle?.position?.lat && selectedVehicle?.position?.lng) {
//       mapRef.current.panTo(selectedVehicle.position);
//       mapRef.current.setZoom(17);
//       return;
//     }

//     if (filteredVehicles.length > 1) {
//       const bounds = new window.google.maps.LatLngBounds();
//       filteredVehicles.forEach((v) => {
//         if (v.position?.lat && v.position?.lng) bounds.extend(v.position);
//       });
//       mapRef.current.fitBounds(bounds);

//       setTimeout(() => {
//         const zoom = mapRef.current.getZoom();
//         if (zoom > 16) mapRef.current.setZoom(16);
//         if (zoom < 5) mapRef.current.setZoom(5);
//       }, 300);
//     } else if (filteredVehicles.length === 1) {
//       mapRef.current.panTo(filteredVehicles[0].position);
//       mapRef.current.setZoom(13);
//     }
//   }, [selectedVehicle, filteredVehicles, autoFocus]);

//   const mapCenter = useMemo(() => {
//     if (selectedVehicle?.position) return selectedVehicle.position;
//     return defaultCenter;
//   }, [selectedVehicle]);

//   return (
//     <>
//       <div style={{ position: "absolute", top: 20, right: 20, display: "flex", flexDirection: "column", gap: "10px", zIndex: 1 }}>
//         <button style={btnStyle} onClick={() => setShowAllLabels(!showAllLabels)} title="Toggle Labels">
//           <img src={showAllLabels ? label_dark : label} alt="Labels" style={{ width: 22, height: 22 }} />
//         </button>
//         <button style={btnStyle} onClick={() => setMapType(mapType === "roadmap" ? "satellite" : "roadmap")} title="Map Type">
//           <img src={mapType === "satellite" ? satellite : satellite_dark} alt="Type" style={{ width: 22, height: 22 }} />
//         </button>
//         <button style={btnStyle} onClick={() => setAutoFocus(!autoFocus)} title="Auto Focus">
//           <img src={autoFocus ? focus : focus_dark} alt="Focus" style={{ width: 22, height: 22 }} />
//         </button>
//         <button style={btnStyle} onClick={() => setShowGeofences(!showGeofences)} title="Toggle Geofences">
//           <svg
//             width="22"
//             height="22"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke={showGeofences ? "#2bbf9f" : "#666"}
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           >
//             <circle cx="12" cy="12" r="8" strokeDasharray="3 3"></circle>
//             <circle cx="12" cy="12" r="1.6" fill={showGeofences ? "#2bbf9f" : "#666"} stroke="none"></circle>
//           </svg>
//         </button>
//         <button style={btnStyle} onClick={() => setEnableClustering(!enableClustering)} title="Toggle Clustering">
//           <svg
//             width="22"
//             height="22"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke={enableClustering ? "#2bbf9f" : "#666"}
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           >
//             <circle cx="12" cy="12" r="3"></circle>
//             <circle cx="19" cy="5" r="2"></circle>
//             <circle cx="5" cy="5" r="2"></circle>
//             <circle cx="19" cy="19" r="2"></circle>
//             <circle cx="5" cy="19" r="2"></circle>
//             <path d="M10.5 10.5L7 7 M13.5 10.5L17 7 M10.5 13.5L7 17 M13.5 13.5L17 17"></path>
//           </svg>
//         </button>
//       </div>

//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={autoFocus ? mapCenter : undefined}
//         zoom={selectedVehicle ? 15 : 9}
//         onLoad={(map) => {
//           mapRef.current = map;
//           setIsMapReady(true); // Map is ready to accept bounds
//         }}
//         options={{ mapTypeId: mapType, mapTypeControl: false, streetViewControl: false, fullscreenControl: false }}
//       >
//         {selectedVehicle ? (
//           <>
//             {animatedPosition && (
//               <Circle
//                 center={animatedPosition}
//                 radius={pulseRadius}
//                 options={{
//                   strokeColor: getVehicleColor(selectedVehicle),
//                   strokeOpacity: 0.8,
//                   strokeWeight: 2,
//                   fillColor: getVehicleColor(selectedVehicle),
//                   fillOpacity: pulseOpacity,
//                 }}
//               />
//             )}
//             <SmoothMarker
//               position={selectedVehicle.position}
//               vehicle={selectedVehicle}
//               onPositionChange={setAnimatedPosition}
//               onClick={() => setOpenInfoVehicleId(prev => prev === selectedVehicle.vehicleNumber ? null : selectedVehicle.vehicleNumber)}
//             >
//               {(openInfoVehicleId === selectedVehicle.vehicleNumber || showAllLabels) && (
//                 <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
//                   <MDBox>
//                     <MDTypography variant="caption" fontWeight="bold" display="block" color="error">{selectedVehicle.vehicleNumber}</MDTypography>
//                     <MDTypography variant="caption" display="block" color="error">{selectedVehicle.vehicleNickName}</MDTypography>
//                   </MDBox>
//                 </InfoWindow>
//               )}
//             </SmoothMarker>
//           </>
//         ) : (
//           <>
//             {enableClustering ? (
//               <MarkerClusterer options={{ gridSize: 30, imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" }}>
//                 {(clusterer) => (
//                   <>
//                     {filteredVehicles.map((vehicle) => (
//                       <SmoothMarker
//                         key={vehicle.vehicleNumber}
//                         position={vehicle.position}
//                         vehicle={vehicle}
//                         clusterer={clusterer}
//                         onClick={() => {
//                           dispatch(setSelectedVehicleNumber(vehicle.vehicleNumber));
//                           onVehicleSelect?.(vehicle.vehicleNumber);
//                         }}
//                       >
//                         {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
//                           <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
//                             <MDBox>
//                               <MDTypography variant="h6">{vehicle.vehicleNumber}</MDTypography>
//                               <MDTypography variant="h6">{vehicle.vehicleNickName}</MDTypography>
//                             </MDBox>
//                           </InfoWindow>
//                         )}
//                       </SmoothMarker>
//                     ))}
//                   </>
//                 )}
//               </MarkerClusterer>
//             ) : (
//               <>
//                 {filteredVehicles.map((vehicle) => (
//                   <SmoothMarker
//                     key={vehicle.vehicleNumber}
//                     position={vehicle.position}
//                     vehicle={vehicle}
//                     clusterer={undefined}
//                     onClick={() => {
//                       dispatch(setSelectedVehicleNumber(vehicle.vehicleNumber));
//                       onVehicleSelect?.(vehicle.vehicleNumber);
//                     }}
//                   >
//                     {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
//                       <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
//                         <MDBox>
//                           <MDTypography variant="h6">{vehicle.vehicleNumber}</MDTypography>
//                           <MDTypography variant="h6">{vehicle.vehicleNickName}</MDTypography>
//                         </MDBox>
//                       </InfoWindow>
//                     )}
//                   </SmoothMarker>
//                 ))}
//               </>
//             )}
//           </>
//         )}

//         {selectedVehicle?.routeCoordinates?.length > 0 && selectedVehicle.journeyAvailable && (
//           <Polyline
//             path={window.google?.maps?.geometry?.encoding?.decodePath(selectedVehicle.routeCoordinates) || []}
//             options={{ strokeColor: "#2196F3", strokeOpacity: 1.0, strokeWeight: 5 }}
//           />
//         )}

//         {selectedVehicle?.journeyAvailable && selectedVehicle.stops && Object.entries(selectedVehicle.stops).map(([stopId, stop], index) => (
//           <Marker
//             key={stopId}
//             position={{ lat: parseFloat(stop.location.latitude), lng: parseFloat(stop.location.longitude) }}
//             icon={{ url: StopIcon, scaledSize: new window.google.maps.Size(28, 28) }}
//             label={{ color: "#fff", text: `${index + 1}`, fontSize: "1em" }}
//             onClick={() => setSelectedStop({ id: stopId, name: stop.locationName })}
//           >
//             {selectedStop?.id === stopId && (
//               <InfoWindow onCloseClick={() => setSelectedStop(null)}>
//                 <MDTypography variant="h6">{stop.locationName}</MDTypography>
//               </InfoWindow>
//             )}
//           </Marker>
//         ))}

//         {/* {showGeofences && geoFences.map((gf, idx) => {
//           const loc = gf.data?.location;
//           if (!loc?.latitude) return null;
//           return (
//             <Circle
//               key={`gf-${idx}`}
//               center={{ lat: loc.latitude, lng: loc.longitude }}
//               radius={gf.data?.radius || 100}
//               options={{ strokeColor: "#666", fillColor: "#000", fillOpacity: 0.3 }}
//             />
//           );
//         })} */}
//         {showGeofences && geoFences.map((gf, idx) => {
//           const data = gf.data || {};

//           if (gf.type === "POLYGON" && Array.isArray(data.coordinates) && data.coordinates.length > 0) {
//             const paths = data.coordinates.map(([lng, lat]) => ({ lat, lng }));
//             return (
//               <Polygon
//                 key={`gf-polygon-${gf.filterId || idx}`}
//                 paths={paths}
//                 options={{ strokeColor: "#666", strokeWeight: 2, fillColor: "#000", fillOpacity: 0.3 }}
//               />
//             );
//           }

//           const loc = data.location;
//           if (!loc?.latitude) return null;
//           return (
//             <Circle
//               key={`gf-circle-${gf.filterId || idx}`}
//               center={{ lat: loc.latitude, lng: loc.longitude }}
//               radius={data.radius || 100}
//               options={{ strokeColor: "#666", fillColor: "#000", fillOpacity: 0.3 }}
//             />
//           );
//         })}
//       </GoogleMap>

//       <VehicleDashboard
//         vehicle={selectedVehicle}
//         onClose={() => {
//           setSelectedVehicle(null);
//           dispatch(setSelectedVehicleNumber(null));
//         }}
//       />
//     </>
//   );
// };

// GoogleMapView.propTypes = {
//   onVehicleSelect: PropTypes.func,
// };

// export default GoogleMapView;

import {
  GoogleMap,
  Marker,
  InfoWindow,
  Polyline,
  Polygon,
  Circle,
  MarkerClusterer,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useState, useEffect, useMemo, useRef } from "react";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios from "axios";

// Assets
import StopIcon from "assets/images/stop_marker.png";
import focus from "assets/focus.png";
import focus_dark from "assets/focus-dark.png";
import satellite from "assets/satellite.png";
import satellite_dark from "assets/satellite-dark.png";
import label_dark from "assets/label-dark.png";
import label from "assets/label.png";
import realShip from "assets/images/ship.png"

// Components & Redux Actions
import VehicleDashboard from "./VehicleDashboard";
import { setSelectedVehicleNumber } from "../../features/live_map/fleetSlice";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "../../config";

const containerStyle = {
  width: "100%",
  height: "880px",
  borderRadius: "10px",
};

const defaultCenter = {
  lat: 3.2028,
  lng: 73.2207
};

const btnStyle = {
  background: "#fff",
  padding: "4px",
  borderRadius: "8px",
  cursor: "pointer",
  border: "none",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "30px",
  minHeight: "30px"
};

// --- Icon Caching & Processing ---
const iconCache = {};
const getCachedIcon = async (bearing = 0) => {
  const safeBearing = parseFloat(bearing) || 0;
  const cacheKey = `bus-${safeBearing}`;
  if (iconCache[cacheKey]) return iconCache[cacheKey];

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const size = 120;

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      canvas.width = size;
      canvas.height = size;
      ctx.translate(size / 2, size / 2);
      ctx.rotate((safeBearing * Math.PI) / 180);
      ctx.translate(-size / 2, -size / 2);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, 0, 0, size, size);
      const url = canvas.toDataURL();
      iconCache[cacheKey] = url;
      resolve(url);
    };
    img.onerror = () => resolve(realShip);
    img.src = realShip;
  });
};

const getVehicleColor = (vehicle) => {
  const speed = parseFloat(vehicle.speed);
  const now = Date.now();
  const isStale = vehicle.rawTime && vehicle.rawTime + 3600000 < now;
  if (isStale) return "#9e9e9e";
  if (vehicle.ignition === "ON" && speed > 0) return "#4caf50";
  if (vehicle.ignition === "ON" && speed === 0) return "#ff9800";
  if (vehicle.ignition === "OFF") return "#f44336";
  return "#9e9e9e";
};

// --- SmoothMarker Component ---
const SmoothMarker = ({ position, vehicle, children, onPositionChange, clusterer, ...props }) => {
  const [renderPosition, setRenderPosition] = useState(position);
  const positionRef = useRef(position);
  const animationRef = useRef(null);
  const [iconUrl, setIconUrl] = useState("");
  const [marker, setMarker] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadIcon = async () => {
      const bearing = parseFloat(vehicle.bearing) || 0;
      const icon = await getCachedIcon(bearing);
      if (isMounted) setIconUrl(icon);
    };
    loadIcon();
    return () => { isMounted = false; };
  }, [vehicle.bearing]);

  useEffect(() => {
    const startPos = positionRef.current;
    const endPos = position;
    if (!startPos || !endPos) return;
    if (startPos.lat === endPos.lat && startPos.lng === endPos.lng) return;

    const distanceThreshold = 0.5; // If marker jumps too far suddenly
    if (Math.abs(startPos.lat - endPos.lat) > distanceThreshold || Math.abs(startPos.lng - endPos.lng) > distanceThreshold) {
      setRenderPosition(endPos);
      positionRef.current = endPos;
      // 🔥 FIX: the status circle listens to onPositionChange, which previously only
      // fired inside the animate() loop below. On a hard jump we returned early
      // without calling it, so the circle kept sitting at the old spot while the
      // marker snapped ahead. Notify it here too so both move together.
      onPositionChange && onPositionChange(endPos);

      // 🔥 FIX: Force clusterer to repaint so it doesn't lose the marker when it jumps
      if (clusterer && typeof clusterer.repaint === 'function') {
        setTimeout(() => clusterer.repaint(), 50);
      }
      return;
    }

    const startTime = performance.now();
    const duration = 4000;
    const animate = (time) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const lat = startPos.lat + (endPos.lat - startPos.lat) * progress;
      const lng = startPos.lng + (endPos.lng - startPos.lng) * progress;
      const currentPos = { lat, lng };

      setRenderPosition(currentPos);
      positionRef.current = currentPos;
      onPositionChange && onPositionChange(currentPos);

      if (progress < 1) animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);
    return () => { if (animationRef.current) cancelAnimationFrame(animationRef.current); };
  }, [position, clusterer]);

  return (
    <Marker
      position={renderPosition}
      clusterer={clusterer}
      onLoad={(m) => setMarker(m)}
      icon={{
        url: iconUrl,
        scaledSize: new window.google.maps.Size(60, 60),
        anchor: new window.google.maps.Point(30, 30),
      }}
      {...props}
    >
      {marker && children}
    </Marker>
  );
};

// --- MAIN COMPONENT ---
const GoogleMapView = ({ onVehicleSelect }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const { myThings, latestUpdates, selectedVehicleNumber, activeFilter, geoFences, searchQuery } = useSelector((state) => state.fleet);

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedStop, setSelectedStop] = useState(null);
  const [openInfoVehicleId, setOpenInfoVehicleId] = useState(null);

  const mapRef = useRef(null);
  const [isMapReady, setIsMapReady] = useState(false);

  const [pulseRadius, setPulseRadius] = useState(20);
  const [pulseOpacity, setPulseOpacity] = useState(0.4);
  const [animatedPosition, setAnimatedPosition] = useState(null);
  const [showAllLabels, setShowAllLabels] = useState(false);
  const [mapType, setMapType] = useState("hybrid");

  const [autoFocus, setAutoFocus] = useState(false); // Default OFF — continuous tracking as the vehicle moves
  const [enableClustering, setEnableClustering] = useState(true);
  const [showGeofences, setShowGeofences] = useState(true); // Default ON

  const initialFocusDone = useRef(false);
  const lastFocusedVehicleRef = useRef(null); // tracks which vehicle we've already auto-centered on

  // 🗺️ Ye component apna khud ka Google Maps script load karta hai — pehle
  // ye maan liya jaata tha ki koi aur page (jaise geoFence create) already
  // load kar chuka hoga, jiski wajah se seedhe dashboard/live-map pe aane par
  // "google is not defined" crash aata tha (script abhi load hi nahi hui thi).
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  // Pulse effect logic
  useEffect(() => {
    if (!selectedVehicle) return;
    let growing = true;
    const interval = setInterval(() => {
      setPulseRadius((prev) => {
        if (prev > 60) growing = false;
        if (prev < 30) growing = true;
        return growing ? prev + 4 : prev - 4;
      });
      setPulseOpacity((prev) => prev > 0.4 ? 0.1 : 0.4);
    }, 100);
    return () => clearInterval(interval);
  }, [selectedVehicle]);

  // Data mapping logic
  const vehicles = useMemo(() => {
    if (!myThings) return [];
    return Object.entries(myThings).map(([vehicleNumber, data]) => {
      const latest = latestUpdates[vehicleNumber]?.latest?.MOBILE || data?.latest?.MOBILE || {};
      const location = latest?.location || {};
      const journeyAvailable = data?.journeyAvailable === true;
      const journeyData = data?.currentJourney || {};
      const stops = data?.stops || {};

      const lat = parseFloat(location.latitude);
      const lng = parseFloat(location.longitude);
      const hasValidLocation = !isNaN(lat) && !isNaN(lng);

      return {
        vehicleNumber: data?.thing?.thingId,
        vehicleNickName: data?.thing?.nickName,
        position: hasValidLocation ? { lat, lng } : null,
        hasValidLocation: hasValidLocation,
        ignition: latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
        bearing: latest?.bearing ?? data?.latest?.MOBILE?.bearing,
        speed: latest?.speed ? parseFloat(latest.speed).toFixed(2) : "0.00",
        rawTime: latest?.updatedAt || "",
        routeCoordinates: journeyData?.wayPointsPolyLine || [],
        stops: journeyAvailable ? stops || {} : {},
        geofence: journeyData?.geofence || [],
        journeyAvailable,
      };
    });
  }, [myThings, latestUpdates]);

  const filteredVehicles = useMemo(() => {
    const now = Date.now();

    return vehicles.filter((v) => {
      // 🔥 FIX: Hide vehicles that don't have valid coordinates yet
      if (!v.hasValidLocation || !v.position) return false;

      let matchesFilter = true;
      const isStale = v.rawTime + 3600000 < now;
      const speed = parseFloat(v.speed);

      switch (activeFilter) {
        case "@running":
          matchesFilter = !isStale && v.ignition === "ON" && speed >= 0.25;
          break;
        case "@idle":
          matchesFilter = !isStale && v.ignition === "ON" && speed < 0.25;
          break;
        case "@parked":
          matchesFilter = !isStale && v.ignition === "OFF";
          break;
        case "@offline":
          matchesFilter = isStale;
          break;
        case "@onroute":
          matchesFilter = v.journeyAvailable === true;
          break;
        default:
          matchesFilter = true;
      }

      // 🔥 FIX: searchQuery doubles as the active-filter sentinel (e.g. "@running") when a
      // filter chip is selected — that's not real search text, so it must not be matched
      // against vehicle number/nickname, or every vehicle gets filtered out.
      const rawQuery = searchQuery || "";
      const q = rawQuery.startsWith("@") ? "" : rawQuery.toLowerCase();
      const matchesSearch = v.vehicleNumber.toLowerCase().includes(q) ||
        v.vehicleNickName.toLowerCase().includes(q);

      return matchesFilter && matchesSearch;
    });
  }, [vehicles, activeFilter, searchQuery]);

  // Sync selected vehicle with Redux State
  useEffect(() => {
    if (!selectedVehicleNumber) {
      setSelectedVehicle(null);
      setOpenInfoVehicleId(null);
      return;
    }
    const found = vehicles.find(v => String(v.vehicleNumber) === String(selectedVehicleNumber));
    setSelectedVehicle(found || null);
  }, [vehicles, selectedVehicleNumber]);

  // 🎯 Center & zoom on a vehicle the moment it's selected (clicking its card or its
  // marker) — independent of the "Auto Focus" toggle, which only controls whether the
  // map keeps following the vehicle as it continues to move afterwards.
  useEffect(() => {
    if (!mapRef.current || !selectedVehicle?.position) {
      if (!selectedVehicle) lastFocusedVehicleRef.current = null;
      return;
    }
    if (lastFocusedVehicleRef.current !== selectedVehicle.vehicleNumber) {
      mapRef.current.panTo(selectedVehicle.position);
      mapRef.current.setZoom(17);
      lastFocusedVehicleRef.current = selectedVehicle.vehicleNumber;
    }
  }, [selectedVehicle]);


  // 🔥 SECURE ONE-TIME INITIAL FOCUS LOGIC
  useEffect(() => {
    if (!isLoaded || !isMapReady || !mapRef.current || initialFocusDone.current) return;

    if (filteredVehicles.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      filteredVehicles.forEach((v) => {
        if (v.position?.lat && v.position?.lng) {
          bounds.extend(v.position);
        }
      });

      mapRef.current.fitBounds(bounds);

      // Safe zoom handling using bounds_changed event
      window.google.maps.event.addListenerOnce(mapRef.current, "bounds_changed", () => {
        const zoom = mapRef.current.getZoom();
        if (zoom > 16) mapRef.current.setZoom(16);
        if (zoom < 5) mapRef.current.setZoom(5);
      });

      initialFocusDone.current = true; // Mark as done
    }
  }, [filteredVehicles, isMapReady, isLoaded]);


  // Autofocus logic for manual toggles/selections
  useEffect(() => {
    if (!isLoaded || !autoFocus || !mapRef.current) return;

    if (selectedVehicle?.position?.lat && selectedVehicle?.position?.lng) {
      mapRef.current.panTo(selectedVehicle.position);
      mapRef.current.setZoom(17);
      return;
    }

    if (filteredVehicles.length > 1) {
      const bounds = new window.google.maps.LatLngBounds();
      filteredVehicles.forEach((v) => {
        if (v.position?.lat && v.position?.lng) bounds.extend(v.position);
      });
      mapRef.current.fitBounds(bounds);

      setTimeout(() => {
        const zoom = mapRef.current.getZoom();
        if (zoom > 16) mapRef.current.setZoom(16);
        if (zoom < 5) mapRef.current.setZoom(5);
      }, 300);
    } else if (filteredVehicles.length === 1) {
      mapRef.current.panTo(filteredVehicles[0].position);
      mapRef.current.setZoom(13);
    }
  }, [selectedVehicle, filteredVehicles, autoFocus, isLoaded]);

  const mapCenter = useMemo(() => {
    if (selectedVehicle?.position) return selectedVehicle.position;
    return defaultCenter;
  }, [selectedVehicle]);

  if (!isLoaded) {
    return (
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%", height: "880px", borderRadius: "10px" }}
      >
        <MDTypography variant="body1">Loading map...</MDTypography>
      </MDBox>
    );
  }

  return (
    <>
      <style>{`
        .gm-style .gm-style-iw-c {
          background-color: rgba(255, 255, 255, 0.3) !important;
          box-shadow: none !important;
          backdrop-filter: blur(2px);
        }
        .gm-style .gm-style-iw-t::after,
        .gm-style .gm-style-iw-tc::after {
          background: linear-gradient(45deg, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 51%, rgba(255,255,255,0) 100%) !important;
          box-shadow: none !important;
        }
        .gm-style .gm-style-iw-d {
          overflow: visible !important;
        }
      `}</style>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", flexDirection: "column", gap: "10px", zIndex: 1 }}>
        <button style={btnStyle} onClick={() => setShowAllLabels(!showAllLabels)} title="Toggle Labels">
          <img src={showAllLabels ? label_dark : label} alt="Labels" style={{ width: 22, height: 22 }} />
        </button>
        <button style={btnStyle} onClick={() => setMapType(mapType === "roadmap" ? "satellite" : "roadmap")} title="Map Type">
          <img src={mapType === "satellite" ? satellite : satellite_dark} alt="Type" style={{ width: 22, height: 22 }} />
        </button>
        <button style={btnStyle} onClick={() => setAutoFocus(!autoFocus)} title="Auto Focus">
          <img src={autoFocus ? focus : focus_dark} alt="Focus" style={{ width: 22, height: 22 }} />
        </button>
        <button style={btnStyle} onClick={() => setShowGeofences(!showGeofences)} title="Toggle Geofences">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={showGeofences ? "#2bbf9f" : "#666"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="8" strokeDasharray="3 3"></circle>
            <circle cx="12" cy="12" r="1.6" fill={showGeofences ? "#2bbf9f" : "#666"} stroke="none"></circle>
          </svg>
        </button>
        <button style={btnStyle} onClick={() => setEnableClustering(!enableClustering)} title="Toggle Clustering">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={enableClustering ? "#2bbf9f" : "#666"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3"></circle>
            <circle cx="19" cy="5" r="2"></circle>
            <circle cx="5" cy="5" r="2"></circle>
            <circle cx="19" cy="19" r="2"></circle>
            <circle cx="5" cy="19" r="2"></circle>
            <path d="M10.5 10.5L7 7 M13.5 10.5L17 7 M10.5 13.5L7 17 M13.5 13.5L17 17"></path>
          </svg>
        </button>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={autoFocus ? mapCenter : undefined}
        zoom={selectedVehicle ? 15 : 9}
        onLoad={(map) => {
          mapRef.current = map;
          setIsMapReady(true); // Map is ready to accept bounds
        }}
        options={{ mapTypeId: mapType, mapTypeControl: false, streetViewControl: false, fullscreenControl: false }}
      >
        {selectedVehicle ? (
          <>
            {animatedPosition && (
              <Circle
                center={animatedPosition}
                radius={pulseRadius}
                options={{
                  strokeColor: getVehicleColor(selectedVehicle),
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: getVehicleColor(selectedVehicle),
                  fillOpacity: pulseOpacity,
                }}
              />
            )}
            <SmoothMarker
              position={selectedVehicle.position}
              vehicle={selectedVehicle}
              onPositionChange={setAnimatedPosition}
              onClick={() => setOpenInfoVehicleId(prev => prev === selectedVehicle.vehicleNumber ? null : selectedVehicle.vehicleNumber)}
            >
              {(openInfoVehicleId === selectedVehicle.vehicleNumber || showAllLabels) && (
                <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
                  <MDBox>
                    <MDTypography variant="caption" fontWeight="bold" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{selectedVehicle.vehicleNumber}</MDTypography>
                    <MDTypography variant="caption" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{selectedVehicle.vehicleNickName}</MDTypography>
                  </MDBox>
                </InfoWindow>
              )}
            </SmoothMarker>
          </>
        ) : (
          <>
            {enableClustering ? (
              <MarkerClusterer options={{ gridSize: 30, imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" }}>
                {(clusterer) => (
                  <>
                    {filteredVehicles.map((vehicle) => (
                      <SmoothMarker
                        key={vehicle.vehicleNumber}
                        position={vehicle.position}
                        vehicle={vehicle}
                        clusterer={clusterer}
                        onClick={() => {
                          dispatch(setSelectedVehicleNumber(vehicle.vehicleNumber));
                          onVehicleSelect?.(vehicle.vehicleNumber);
                        }}
                      >
                        {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
                          <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
                            <MDBox>
                              <MDTypography variant="caption" fontWeight="bold" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{vehicle.vehicleNumber}</MDTypography>
                              <MDTypography variant="caption" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{vehicle.vehicleNickName}</MDTypography>
                            </MDBox>
                          </InfoWindow>
                        )}
                      </SmoothMarker>
                    ))}
                  </>
                )}
              </MarkerClusterer>
            ) : (
              <>
                {filteredVehicles.map((vehicle) => (
                  <SmoothMarker
                    key={vehicle.vehicleNumber}
                    position={vehicle.position}
                    vehicle={vehicle}
                    clusterer={undefined}
                    onClick={() => {
                      dispatch(setSelectedVehicleNumber(vehicle.vehicleNumber));
                      onVehicleSelect?.(vehicle.vehicleNumber);
                    }}
                  >
                    {(openInfoVehicleId === vehicle.vehicleNumber || showAllLabels) && (
                      <InfoWindow onCloseClick={() => setOpenInfoVehicleId(null)}>
                        <MDBox>
                          <MDTypography variant="caption" fontWeight="bold" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{vehicle.vehicleNumber}</MDTypography>
                          <MDTypography variant="caption" display="block" sx={{ color: mapType === "roadmap" ? "#000 !important" : "#fff !important", fontSize: "0.7rem" }}>{vehicle.vehicleNickName}</MDTypography>
                        </MDBox>
                      </InfoWindow>
                    )}
                  </SmoothMarker>
                ))}
              </>
            )}
          </>
        )}

        {selectedVehicle?.routeCoordinates?.length > 0 && selectedVehicle.journeyAvailable && (
          <Polyline
            path={window.google?.maps?.geometry?.encoding?.decodePath(selectedVehicle.routeCoordinates) || []}
            options={{ strokeColor: "#2196F3", strokeOpacity: 1.0, strokeWeight: 5 }}
          />
        )}

        {selectedVehicle?.journeyAvailable && selectedVehicle.stops && Object.entries(selectedVehicle.stops).map(([stopId, stop], index) => (
          <Marker
            key={stopId}
            position={{ lat: parseFloat(stop.location.latitude), lng: parseFloat(stop.location.longitude) }}
            icon={{ url: StopIcon, scaledSize: new window.google.maps.Size(28, 28) }}
            label={{ color: "#fff", text: `${index + 1}`, fontSize: "1em" }}
            onClick={() => setSelectedStop({ id: stopId, name: stop.locationName })}
          >
            {selectedStop?.id === stopId && (
              <InfoWindow onCloseClick={() => setSelectedStop(null)}>
                <MDTypography variant="h6">{stop.locationName}</MDTypography>
              </InfoWindow>
            )}
          </Marker>
        ))}

        {/* {showGeofences && geoFences.map((gf, idx) => {
          const loc = gf.data?.location;
          if (!loc?.latitude) return null;
          return (
            <Circle
              key={`gf-${idx}`}
              center={{ lat: loc.latitude, lng: loc.longitude }}
              radius={gf.data?.radius || 100}
              options={{ strokeColor: "#666", fillColor: "#000", fillOpacity: 0.3 }}
            />
          );
        })} */}
        {showGeofences && geoFences.map((gf, idx) => {
          const data = gf.data || {};

          if (gf.type === "POLYGON" && Array.isArray(data.coordinates) && data.coordinates.length > 0) {
            const paths = data.coordinates.map(([lng, lat]) => ({ lat, lng }));
            return (
              <Polygon
                key={`gf-polygon-${gf.filterId || idx}`}
                paths={paths}
                options={{ strokeColor: "#666", strokeWeight: 2, fillColor: "#000", fillOpacity: 0.3 }}
              />
            );
          }

          const loc = data.location;
          if (!loc?.latitude) return null;
          return (
            <Circle
              key={`gf-circle-${gf.filterId || idx}`}
              center={{ lat: loc.latitude, lng: loc.longitude }}
              radius={data.radius || 100}
              options={{ strokeColor: "#666", fillColor: "#000", fillOpacity: 0.3 }}
            />
          );
        })}
      </GoogleMap>

      <VehicleDashboard
        vehicle={selectedVehicle}
        onClose={() => {
          setSelectedVehicle(null);
          dispatch(setSelectedVehicleNumber(null));
        }}
      />
    </>
  );
};

GoogleMapView.propTypes = {
  onVehicleSelect: PropTypes.func,
};

export default GoogleMapView;